import React from "react";

import styles from "./index.module.scss";
import { ContentHeadlineItem } from "../../../types";

interface Props {
  active?: number;
  headlines: Array<ContentHeadlineItem>;
  onClick: (id: number) => void;
}

class TableOfContents extends React.PureComponent<Props> {
  public render() {
    const { active, headlines, onClick } = this.props;

    return (
      <div className={styles.container}>
        {headlines.map((headline, i) => (
          <div className={styles.content} key={headline.id}>
            <div className={styles.row}>
              <div className={styles.left}>
                <div className={styles.bulletWrapper}>
                  <div className={styles.bullet}>
                    {active === headline.id && <div className={styles.point} />}
                  </div>
                </div>
                <div className={styles.flexLine} />
              </div>
              <div className={styles.title}>
                {active === headline.id ? (
                  <div className={styles.titleText}>{headline.text}</div>
                ) : (
                  <div
                    className={styles.link}
                    onClick={() => onClick(headline.id)}
                  >
                    {headline.text}
                  </div>
                )}
              </div>
            </div>
            {i + 1 !== headlines.length && <div className={styles.line} />}
          </div>
        ))}
      </div>
    );
  }
}

export { TableOfContents };
